module.exports = __webpack_public_path__ + "img/product-placeholder-5.1fa3ccc.png";